import * as React from 'react';

import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';

import { Filter } from './filter';
import { Sort } from './sort';

export interface SortFilterProps {
  loading?: boolean;
  inDialog?: boolean;
}

export const SortFilter: React.FC<SortFilterProps> = ({ loading, inDialog }) => (
  <UitkLayoutGrid columns={1}>
    <UitkLayoutGridItem colSpan="all" className="form-truncate">
      <fieldset aria-busy={loading} data-testid="sort-filter--fieldset">
        {inDialog && <Sort inDialog={true} />}
        {<Filter inDialog={inDialog} />}
      </fieldset>
    </UitkLayoutGridItem>
  </UitkLayoutGrid>
);
